import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import * as moment from "moment";
import { UploadService } from "../services/core/documents/upload.service";
import { imageProcessing } from "./image-processing-utils";
import * as XLSX from 'xlsx';

export function exportToExcel(filename: any, sheets: any) {
  // Create a new workbook
  var wb = XLSX.utils.book_new();

  // Iterate through the sheets object to add sheets to the workbook
  for (var sheetName in sheets) {
    if (sheets.hasOwnProperty(sheetName)) {
      var ws_data = sheets[sheetName];
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    }
  }

  // Write the workbook to a file
  var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

  // Create a Blob from the binary data
  var buf = new ArrayBuffer(wbout.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i < wbout.length; ++i) {
    view[i] = wbout.charCodeAt(i) & 0xFF;
  }
  var blob = new Blob([buf], { type: 'application/octet-stream' });

  // Create a link element and trigger a download
  var link = document.createElement("a");
  if (link.download !== undefined) { // feature detection
    var url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


}

export const timeZone = "America/New_York";

export const getShiftDays = [
  { label: "Sun", day: 0 },
  { label: "Mon", day: 1 },
  { label: "Tue", day: 2 },
  { label: "Wed", day: 3 },
  { label: "Thu", day: 4 },
  { label: "Fri", day: 5 },
  { label: "Sat", day: 6 }
];

export const getstandingOrderDays = [
  { label: "monday", day: 1, checked: false },
  { label: "tuesday", day: 2, checked: false },
  { label: "wednesday", day: 3, checked: false },
  { label: "thursday", day: 4, checked: false },
  { label: "friday", day: 5, checked: false },
  { label: "saturday", day: 6, checked: false },
  { label: "sunday", day: 0, checked: false }
];


export const CAPACITY: any = ['1', '2', '3', '4', '5', '6', '7'];

export const FUELTYPES: any = [
  { value: "petrol", key: "Petrol" },
  { value: "diesel", key: "Diesel" },
  { value: "octane", key: "HighOctane" },
  { value: "hybrid", key: "Hybrid" },
  { value: "ev", key: "EV" }
];

export const BODYTYPES: any = [
  { value: "minicut", key: "Mini Cut" },
  { value: "fullcut", key: "Full Cut" }
];

export function getAddressDetails(locationData: any) {
  let address: any = {
    aptOrSuite: '',
    street: '',
    city: '',
    state: '',
    zipCode: ''
  };
  locationData.address_components.forEach((component: any) => {
    if (component.types.includes("street_number")) {
      address.street = component.long_name;
    } else if (component.types.includes("route")) {
      address.street = address.street ? address.street + " " + component.long_name : component.long_name;
    } else if (component.types.includes("subpremise")) {
      address.aptOrSuite = "#" + component.long_name;
    } else if (component.types.includes("locality")) {
      address.city = component.long_name;
    } else if (component.types.includes("administrative_area_level_1")) {
      address.state = component.short_name;
    } else if (component.types.includes("postal_code")) {
      address.zipCode = component.long_name;
    }
  });

  return address;
}

export const states = [
  { value: "AK", name: "Alaska" },
  { value: "AL", name: "Alabama" },
  { value: "AR", name: "Arkansas" },
  { value: "AZ", name: "Arizona" },
  { value: "CA", name: "California" },
  { value: "CO", name: "Colorado" },
  { value: "CT", name: "Connecticut" },
  { value: "DC", name: "DistrictofColumbia" },
  { value: "DE", name: "Delaware" },
  { value: "FL", name: "Florida" },
  { value: "GA", name: "Georgia" },
  { value: "HI", name: "Hawaii" },
  { value: "IA", name: "Iowa" },
  { value: "ID", name: "Idaho" },
  { value: "IL", name: "Illinois" },
  { value: "IN", name: "Indiana" },
  { value: "KS", name: "Kansas" },
  { value: "KY", name: "Kentucky" },
  { value: "LA", name: "Louisiana" },
  { value: "MA", name: "Massachusetts" },
  { value: "MD", name: "Maryland" },
  { value: "ME", name: "Maine" },
  { value: "MI", name: "Michigan" },
  { value: "MN", name: "Minnesota" },
  { value: "MO", name: "Missouri" },
  { value: "MS", name: "Mississippi" },
  { value: "MT", name: "Montana" },
  { value: "NC", name: "NorthCarolina" },
  { value: "ND", name: "NorthDakota" },
  { value: "NE", name: "Nebraska" },
  { value: "NH", name: "NewHampshire" },
  { value: "NJ", name: "NewJersey" },
  { value: "NM", name: "NewMexico" },
  { value: "NV", name: "Nevada" },
  { value: "NY", name: "NewYork" },
  { value: "OH", name: "Ohio" },
  { value: "OK", name: "Oklahoma" },
  { value: "OR", name: "Oregon" },
  { value: "PA", name: "Pennsylvania" },
  { value: "RI", name: "RhodeIsland" },
  { value: "SC", name: "SouthCarolina" },
  { value: "SD", name: "SouthDakota" },
  { value: "TN", name: "Tennessee" },
  { value: "TX", name: "Texas" },
  { value: "UT", name: "Utah" },
  { value: "VA", name: "Virginia" },
  { value: "VT", name: "Vermont" },
  { value: "WA", name: "Washington" },
  { value: "WI", name: "Wisconsin" },
  { value: "WV", name: "WestVirginia" },
  { value: "WY", name: "Wyoming" },
];

export function onTimeChange(controlName: AbstractControl<any, any> | null) {
  const control = controlName
  if (control && control.value._d) {
    control.setValue(control.value.toISOString());
  }
}

export function getFileNameFromUrl(url: any) {
  if (url && url !== '') {
    const urlSegments = url.split('/');
    if (urlSegments)
      return decodeURI(urlSegments[urlSegments.length - 1]);
    else
      return '';
  } else {
    return '';
  }
}

export function uploadDocumentImages(documents: any, formControl: AbstractControl<any, any> | null, uploadService: UploadService) {

  let selectedFile
  if (!(formControl instanceof FormControl)) {
    console.error('Invalid form control provided.');
    return;
  }

  imageProcessing(documents).subscribe({
    next: (result) => {
      selectedFile = result.file;
      if (!selectedFile || !(selectedFile instanceof Blob)) {
        console.error('Invalid file selected.');
        return;
      }

      uploadService.uploadImageToServer(selectedFile).subscribe({
        next: (uploadResult: any) => {
          if (uploadResult.fileUrl) {
            formControl.setValue(uploadResult.fileUrl);
          } else {
            console.error('Upload result does not contain a valid file URL.');
          }
        },
        error: (uploadError: any) => {
          console.error('Error uploading image:', uploadError);
        },
      });
    },
    error: (processingError: any) => {
      console.error('Error processing image:', processingError);
    },
  });
}

export function findServiceArea(zipCode: any, serviceAreas: any) {
  const serviceArea = serviceAreas.find((serviceArea: any) => serviceArea.zipCodes.includes(zipCode));
  return serviceArea ? serviceArea._id : "";
}

export function timeCalculation(trip: any, currentTime: any) {

  const end = moment(trip.scheduleTime);
  const startTime = moment(currentTime);
  const duration = moment.duration(end.diff(startTime));
  return duration.asMinutes();
}

export function phoneNumberLengthValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;

  const digitsOnly = control.value.replace(/\D/g, ''); // removes +, -, spaces, etc.
  console.log("Digits check", digitsOnly)
  if (digitsOnly.length < 10) {
    return { minlength: true };
  }
  if (digitsOnly.length > 13) {
    return { maxlength: true };
  }

  return null;
}

export function allowOnlyNumbersValidator(controlName: string): ValidatorFn {
  return (formGroup: AbstractControl): null => {
    const control = formGroup.get(controlName);
    if (!control) return null;
    let value: string = control.value || '';
    // Remove non-numeric characters
    const numericValue = value.replace(/[^0-9]/g, '');
    const trimmedNumericValue = numericValue.length > 13 ? numericValue.slice(0, 13) : numericValue;
    // Only update if value actually changed
    if (trimmedNumericValue !== value) {
      control.setValue(trimmedNumericValue, { emitEvent: false });
    }
    return null;
  };
}

export function passwordMatchValidator(control: AbstractControl): ValidationErrors | null {

  const password = control.get('password')?.value;
  const confirmPassword = control.get('confirmPassword')?.value;

  if (!password || !confirmPassword) return null;

  if (password !== confirmPassword) {
    return { passwordMismatch: true };
  }

  return null;
}

export function passwordValidator(control: AbstractControl): ValidationErrors | null {

  if (!control.value) return null;

  const password = control.value.trim();

  const hasLetter = /[a-zA-Z]/.test(password);
  const hasDigit = /\d/.test(password);

  if (!hasLetter || !hasDigit || password.length < 8) {
    return { passwordStrength: true };
  }

  return null;
}
export function roundUp(value: number): number {
  return Math.ceil(value);
}